import { SystemField } from "./system-field";

export class StaffShift extends SystemField{
     
     start_datetime?:string;
     end_datetime?:string;
     closed_by_id?:string;
     approved_by_id?:string;
     total_theory_collection?:number;
     total_actual_collection?:number;
     total_discount?:number;
     total_sale_rev?:number;
     over_short?:number;
     staff_end_day_id?:string;
     note?:string;
     transaction_date?:string;
     unbilled_amount?:number;
     owner_id?:string;
}
